import React from 'react';
import logger from '../../utils/logger';

const ProductOverview = ({ 
    products = [], 
    onProductSelect, 
    colorScheme,
    customerName = "",
    isLoading = false 
}) => {
    const color = colorScheme || {
        bg: "#ffffff",
        fg: "#000000",
        border: "#dee2e6",
        headerBg: "#f8f9fa",
        primary: "#007bff",
        secondary: "#6c757d"
    };

    const handleProductClick = (product) => {
        logger.log('🔄 Product selected for detailed view:', product.product_code);
        if (onProductSelect) {
            onProductSelect(product);
        }
    };

    if (isLoading) {
        return (
            <div style={{
                backgroundColor: color.bg,
                border: `1px solid ${color.border}`,
                borderRadius: 8,
                padding: "2rem",
                textAlign: "center"
            }}>
                <div style={{ fontSize: "1.2rem", color: color.secondary }}>
                    🔄 Loading products...
                </div>
            </div>
        );
    }

    if (!products || products.length === 0) {
        return (
            <div style={{
                backgroundColor: color.bg,
                border: `1px solid ${color.border}`,
                borderRadius: 8,
                padding: "2rem",
                textAlign: "center"
            }}>
                <div style={{ fontSize: "1.2rem", color: color.secondary }}>
                    📦 No products found
                </div>
                <div style={{ fontSize: "0.9rem", opacity: 0.7, marginTop: "0.5rem" }}>
                    No warehouse data available for the selected customer
                </div>
            </div>
        );
    }

    return (
        <div style={{
            backgroundColor: color.bg,
            border: `1px solid ${color.border}`,
            borderRadius: 8,
            marginBottom: "2rem"
        }}>
            {/* Header */}
            <div style={{
                padding: "1rem",
                borderBottom: `1px solid ${color.border}`,
                backgroundColor: color.headerBg,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between"
            }}>
                <h4 style={{ margin: 0, color: color.fg, display: "flex", alignItems: "center", gap: "0.5rem" }}>
                    📦 Product Overview
                </h4>
                <div style={{ fontSize: "0.9rem", color: color.secondary }}>
                    {products.length} product{products.length !== 1 ? 's' : ''}
                </div>
            </div>

            {/* Products Grid */}
            <div style={{ padding: "1rem" }}>
                <div style={{
                    display: "grid",
                    gap: "1rem",
                    gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))"
                }}>
                    {products.map((product, index) => {
                        // Debug: log product structure
                        if (index === 0) {

                        }

                        const quantity = product.total_stock || product.quantity || product.total_quantity || product.quantity_count || 0;
                        const palletCount = product.total_pallets || product.pallet_count || product.pallets || 0;

                        return (
                            <div
                                key={product.id || product.product_code || index}
                                onClick={() => handleProductClick(product)}
                                style={{
                                    backgroundColor: color.bg,
                                    border: `1px solid ${color.border}`,
                                    borderRadius: 6,
                                    padding: "1rem",
                                    cursor: "pointer",
                                    transition: "all 0.2s ease",
                                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.borderColor = color.primary;
                                    e.target.style.boxShadow = "0 3px 8px rgba(0,123,255,0.15)";
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.borderColor = color.border;
                                    e.target.style.boxShadow = "0 1px 3px rgba(0,0,0,0.1)";
                                }}
                            >
                                {/* Product Code */}
                                <div style={{
                                    fontSize: "1.1rem",
                                    fontWeight: "bold",
                                    color: color.primary,
                                    marginBottom: "0.5rem"
                                }}>
                                    {product.product_code}
                                </div>

                                {/* Product Name */}
                                <div style={{
                                    fontSize: "0.9rem",
                                    color: color.fg,
                                    marginBottom: "1rem",
                                    lineHeight: "1.4"
                                }}>
                                    {product.product_name}
                                </div>

                                {/* Quantity and Pallets */}
                                <div style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center"
                                }}>
                                    <div style={{ textAlign: "center" }}>
                                        <div style={{
                                            fontSize: "1.5rem",
                                            fontWeight: "bold",
                                            color: "#28a745"
                                        }}>
                                            {quantity.toLocaleString()}
                                        </div>
                                        <div style={{
                                            fontSize: "0.8rem",
                                            color: color.secondary,
                                            textTransform: "uppercase"
                                        }}>
                                            Units
                                        </div>
                                    </div>

                                    <div style={{
                                        width: "1px",
                                        height: "40px",
                                        backgroundColor: color.border
                                    }}></div>

                                    <div style={{ textAlign: "center" }}>
                                        <div style={{
                                            fontSize: "1.5rem",
                                            fontWeight: "bold",
                                            color: "#fd7e14"
                                        }}>
                                            {palletCount}
                                        </div>
                                        <div style={{
                                            fontSize: "0.8rem",
                                            color: color.secondary,
                                            textTransform: "uppercase"
                                        }}>
                                            Pallets
                                        </div>
                                    </div>
                                </div>

                                {/* Click indicator */}
                                <div style={{
                                    marginTop: "1rem",
                                    padding: "0.5rem",
                                    backgroundColor: color.headerBg,
                                    borderRadius: 4,
                                    textAlign: "center",
                                    fontSize: "0.8rem",
                                    color: color.secondary
                                }}>
                                    👆 Click to view warehouse details
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default ProductOverview;